export default __webpack_public_path__ + "static/media/folder-open.1513dc7c.svg";